(() => {
  if (window.__greenShineCommerceV4Ready) return;
  window.__greenShineCommerceV4Ready = true;

  const publish = (eventName, payload) => {
    try {
      const result = window.Shopify?.analytics?.publish?.(eventName, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (error) {
      // Navigation and native Shopify commerce must never be blocked by analytics.
    }
  };

  const contextFor = (element) => {
    const hub = element.closest('[data-gs-contact-hub]');
    const productRoot = element.closest('[data-gs-product-template]');
    return {
      channel: element.dataset.gsChannel || '',
      destination: element.dataset.gsDestination || '',
      context: hub?.dataset.gsContext || document.body.dataset.template || '',
      locale: hub?.dataset.gsLocale || document.documentElement.lang || '',
      product_handle: element.dataset.gsProduct || hub?.dataset.gsProduct || productRoot?.dataset.gsProductHandle || '',
      page_location: window.location.href.split('#')[0]
    };
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const actionElement = event.target.closest('[data-gs-action]');
    if (!actionElement) return;
    const eventNames = {
      contact_click: 'greenshine_contact_click',
      quote_click: 'greenshine_quote_click',
      social_click: 'greenshine_social_click',
      technical_details_click: 'greenshine_technical_details_click',
      product_select: 'greenshine_product_select',
      product_purchase_navigate: 'greenshine_product_purchase_navigate'
    };
    const eventName = eventNames[actionElement.dataset.gsAction];
    if (eventName) publish(eventName, contextFor(actionElement));
  });

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof Element)) return;
    const form = event.target.closest('form[data-gs-native-product-form="true"]');
    if (!form) return;
    const root = form.closest('[data-gs-product-template]');
    const variant = form.querySelector('[name="id"]');
    const quantity = form.querySelector('[name="quantity"]');
    publish('greenshine_buy_intent', {
      context: 'product',
      locale: document.documentElement.lang || '',
      product_handle: root?.dataset.gsProductHandle || '',
      variant_id: variant?.value || '',
      quantity: quantity?.value || '1',
      page_location: window.location.href.split('#')[0]
    });
  });
})();
